module.exports = ".pied {\r\n\tline-height: 50px;\r\n\tborder-top: solid var(--api-gris);\r\n\tbackground-color: var(--api-jaune);\r\n\ttext-align: center;\r\n\tfont-weight: bold;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pied/pied.component.css
// module id = ./src/app/pied/pied.component.css
// module chunks = main